import { wrapView, request } from '../smart_bps/lib/utils'
import { stateToProps } from '../smart_bps/bps/base_view'
import { PROJECT_NAME } from "./constants"
import { SigurListView } from '../lib/SigurListView'
import { SigurModalOrderColumn } from '../common_components/modal_order_column'
import {store} from "../index";

const STATE_FILTERS = [
  { value: 'all', label: 'Все' },
  { value: 'my_work', label: 'Мои (в работе)' },
  { value: 'contractor_reg_wait_accept', label: 'Регистрация подрядчика (ожидают принятия)' },
  { value: 'other_tasks_wait_accept', label: 'Другие задачи (ожидают принятия)' },
  { value: 'done', label: 'Выполнены' },
]

class ListView extends SigurListView {
  constructor(props) {
    super(props)
    this._sessionStateChosen = false
    this.loadStateCounters = this.loadStateCounters.bind(this)
    this.setStateFilter = this.setStateFilter.bind(this)
  }

    renderModals() {
    let modals = [
      <SigurModalOrderColumn project_name={this.project_name}
      attrs={this.props.attrs}
      table_headers={this.props.table_headers}
      user_table_headers={this.props.user_table_headers} />
    ]


    return [...modals, ...(super.renderModals() || [])]
  }

  renderContent() {
    const searchData = this.props.search_data || {}
    const currentState = searchData.state || 'my_work'
    const stateCounters = this.state.stateCounters || {}
    const chips = (
      <div className="card mb-3">
        <div className="card-body py-2">
          <span className="me-2 text-muted small">Задачи:</span>
          {STATE_FILTERS.map(({ value, label }) => (
            <button
              key={value}
              type="button"
              className={`btn btn-sm me-1 ${currentState === value ? 'btn-primary' : 'btn-outline-secondary'}`}
              onClick={() => this.setStateFilter(value, { userInitiated: true })}
            >
              {label} ({stateCounters[value === 'all' ? '__all__' : value] ?? 0})
            </button>
          ))}
        </div>
      </div>
    )
    const content = super.renderContent()
    return [chips, ...(Array.isArray(content) ? content : [content])]
  }

  componentDidMount() {
    super.componentDidMount?.()
    this.loadStateCounters()
    this.updateItems(this.props.list_page || 1)
  }

  componentDidUpdate(prevProps) {
    if (
      !this._sessionStateChosen &&
      (!this.props.search_data?.state || this.props.search_data.state !== 'my_work')
    ) {
      this.setStateFilter('my_work')
    } else if (prevProps.search_data?.state !== this.props.search_data?.state) {
      this.updateItems(1)
    }

    if (prevProps.search_data !== this.props.search_data) {
      this.loadStateCounters()
    }
  }

  loadStateCounters() {
    const current = this.props.search_data || {}
    const { state: _state, ...baseFilterData } = current

    STATE_FILTERS.forEach(({ value }) => {
      const key = value === 'all' ? '__all__' : value
      const filter_data = { ...baseFilterData, state: value }
      request({
        method: 'post',
        url: `/api/${this.project_name}/get_preset_counter`,
        data: {
          filter_data,
          preset: value,
        },
        success: (count) => {
          this.setState((prev) => ({
            stateCounters: { ...prev.stateCounters, [key]: count || 0 },
          }))
        },
      })
    })
  }

  setStateFilter(value, { userInitiated = false } = {}) {
    if (userInitiated && value !== 'my_work') {
      this._sessionStateChosen = true
    }
    const base = this.props.search_data || {}
    store.dispatch({
      type: `${this.project_name}_search`,
      data: { ...base, state: value },
    })
    store.dispatch({ type: `${this.project_name}_list_clean` })
    this.setState({ stateCounters: {} }, () => {
      this.updateItems(1)
    })
  }
}

export default wrapView(ListView, (state) => {
  return stateToProps(state, PROJECT_NAME)
})
